/**
 * @summary - Component that Provides Routine Inspection Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { BemsGraph, FemsGraph,MasterGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import  ReArrangeLabel  from "../../components/commoncomponents/ReArrangeLabel";


async function getAllAssetNoDetails(facilityId) {
  const response = await Axios.get(`${FemsGraph}/api/Predictivemaintenance/GetpredictivemaintenanceAssetNoFetch/${facilityId}?size=3000`);
  if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"assetNo","label"); 
   return reArrangedData;
   }
   return response;
}

async function getAllBemsAssetNoDetails(facilityId) {
    const response = await Axios.get(`${BemsGraph}/api/Predictivemaintenance/GetpredictivemaintenanceAssetNoFetch/${facilityId}?size=3000`);
      if(response?.status !== 'error'){
     const reArrangedData=ReArrangeLabel(response?.data,"assetNo","label"); 
     return reArrangedData;
     }
     return response;
  }

  async function getStaffDetails(facilityId) {  
    const response = await Axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId},1,100`);

    if(response?.status == 200){
     const reArrangedData=ReArrangeLabel(response?.data,"employeename","label"); 
     return reArrangedData;
     }
    // return response;
  }
  async function getBemsStaffDetails(facilityId) {  
    const response = await Axios.get(`${FemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}?size=3000`);
 
      if(response?.status !== 'error'){
     const reArrangedData=ReArrangeLabel(response?.data,"employeename","label"); 
     return reArrangedData;
     }
     return response;
  }

  async function getRIList(facilityId,pageSize,pageIndex,filterModel,sortModel) {  
    const response = await Axios.get(`${FemsGraph}/api/RoutineInspection/GetRoutineInspectionByFacilityid/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);
      return response;
  }

  async function getBemsRIList(facilityId,pageSize,pageIndex,filterModel,sortModel) {  
    const response = await Axios.get(`${BemsGraph}/api/RoutineInspection/GetRoutineInspectionByFacilityid/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);
 
      return response;
  }

  
  async function getRIListForExport(facilityId) {  
    const response = await Axios.get(`${FemsGraph}/api/RoutineInspection/GEtExportData/${facilityId}`);
      return response;
  }

  async function getBemsRIListForExport(facilityId) {  
    const response = await Axios.get(`${BemsGraph}/api/RoutineInspection/GetExportData/${facilityId}`);
 
      return response;
  }
  

  async function getRIForExport(facilityId,filterModel,sortModel) {  
    const response = await Axios.get(`${FemsGraph}/api/RoutineInspection/GEtExportData/${facilityId}?filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);
      return response;
  }

  async function getBemsRIForExport(facilityId,filterModel,sortModel) {  
    const response = await Axios.get(`${BemsGraph}/api/RoutineInspection/GetExportData/${facilityId}?filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);
 
      return response;
  }
   async function getPDMListById(id) {  
    const response = await Axios.get(`${FemsGraph}/api/fempredictivemaintenances/${id}`);
      return response;
  }

  async function createRI(values) {  
    const response = await Axios.post(`${FemsGraph}/api/femroutineinspectscheduledetails`,values);
      return response;
  }

  async function createBemsRI(values) {  
    const response = await Axios.post(`${BemsGraph}/api/bemroutineinspectscheduledetails`,values);
      return response;
  }
  
  async function updateRI(values,id) {  
    const response = await Axios.update(`${FemsGraph}/api/femroutineinspectscheduledetails/${id}`,values);
      return response;
  }

  async function updateBemsRI(values,id) {  
    const response = await Axios.update(`${BemsGraph}/api/bemroutineinspectscheduledetails/${id}`,values);
      return response;
  }

  async function updateRIAssigneorTaskCode(routineInspectionID,staffID,taskCodeID,service) { 
    
    const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
    const checkFemorBem = service === "FEMS" ? "femroutineinspectscheduletracks" : "bemroutineinspectscheduletracks"
    const response = await Axios.update(`${checkGraph}/api/${checkFemorBem}/UpdateTracktableRI/${routineInspectionID}/${staffID}/${taskCodeID}` ); 
    return response;
   }


  async function getBemsPDMListById(facilityId,id) {  
    const response = await Axios.get(`${BemsGraph}/api/bempredictivemaintenances/${id}`);
      return response;
  }
async function addBemsRIscheduleTracks(values) { 
  const response = await Axios.post(`${BemsGraph}/api/bemroutineinspectscheduletracks`,values); 

   return response;
 }
 async function addRIscheduleTracks(values) { 
  const response = await Axios.post(`${FemsGraph}/api/femroutineinspectscheduletracks`,values);
   return response;
 }


 async function updateAllApprovedBy(id,values) { 
  const response = await Axios.update(`${FemsGraph}/api/Graphppmscheduledetails/${id}`,values); 
   if(response?.status !== 'error'){
 
   }
   return response;
 }

 async function removeRIList(id) { 
  const response = await Axios.remove(`${FemsGraph}/api/femroutineinspectscheduledetails/${id}`); 
   return response;
 }
 async function removeBemsRIList(id) { 
  const response = await Axios.remove(`${BemsGraph}/api/bemroutineinspectscheduledetails/${id}`); 
   return response;
 }


 async function getTaskCodeDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleDetailsTaskCodeFetch/${facilityId},${workGroupId}?page=1&size=1000`); 
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"taskcode","label"); 
  return reArrangedData;
  }
  return response;
}
async function getBemsTaskCodeDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleDetailsTaskCodeFetch/${facilityId},${workGroupId}?page=1&size=1000`); 
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"taskcode","label"); 
  return reArrangedData;
  }
  return response;
}


async function getRIShowSchedule(id) { 
  const response = await Axios.get(`${FemsGraph}/api/RoutineInspection/RImaintenancetrackList/${id}?size=400`); 
  return response;
  } 
  async function getBemsRIShowSchedule(id) { 
    const response = await Axios.get(`${BemsGraph}/api/RoutineInspection/RImaintenancetrackList/${id}?size=400`); 
      return response;
    }

    async function removeRIScheduleTracks(id) { 
      const response = await Axios.remove(`${FemsGraph}/api/femroutineinspectscheduletracks/GetFemRIscheduletrack/${id}`); 
      // const response = await Axios.remove(`${FemsGraph}/api/femroutineinspectscheduletracks/${id}`); 
       return response;
     }


     async function removeBemsRIScheduleTracks(id) { 
      const response = await Axios.remove(`${BemsGraph}/api/bemroutineinspectscheduletracks/GetBemRIscheduletrack/${id}`); 
      // const response = await Axios.remove(`${BemsGraph}/api/bemroutineinspectscheduletracks/${id}`); 
       return response;
     }

     async function getBemsAssetNoDetails(facilityId,workGroupId) {
      const response = await Axios.get(`${BemsGraph}/api/RoutineInspection/RIGetAssetNoFetchByFacilityId/${facilityId},${workGroupId}?size=10000`);
         if(response?.status !== 'error'){
      const reArrangedData=await ReArrangeLabel(response?.data,"assetNo","label"); 
      return reArrangedData;
      }
      return response;
    }async function getAssetNoDetails(facilityId,workGroupId) {
      const response = await Axios.get(`${FemsGraph}/api/RoutineInspection/RIGetAssetNoFetchByFacilityId/${facilityId},${workGroupId}?size=10000`); 
      if(response?.status !== 'error'){
      const reArrangedData= await ReArrangeLabel(response?.data,"assetNo","label"); 
      return reArrangedData;
      }
      return response;
    }
    // /api/Predictivemaintenance/GetpredictivemaintenanceAssetNoFetch/{FacilityId}

const RoutineInspectionRepository = {
  getAssetNoDetails,
  getBemsAssetNoDetails,
  getRIList,
  getBemsRIList,
  createRI,
  createBemsRI,
  removeRIList,
  removeBemsRIList,
  removeRIScheduleTracks,
  removeBemsRIScheduleTracks,
  getRIShowSchedule,
  getBemsRIShowSchedule,
  updateRI,
  updateBemsRI,
  getAllBemsAssetNoDetails,
  getAllAssetNoDetails,
  addBemsRIscheduleTracks,
  addRIscheduleTracks,
  updateRIAssigneorTaskCode,

  getTaskCodeDetails,
  getBemsTaskCodeDetails,
  getBemsStaffDetails,
  updateAllApprovedBy,

  getRIForExport,
  getBemsRIForExport,
  getBemsPDMListById,
  getPDMListById,
  getStaffDetails,
  getRIListForExport,
  getBemsRIListForExport
    };
    
    

export default RoutineInspectionRepository;
